import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  COMMISSIONS_GET_NEW_MONTH_SUCCESS,
  COMMISSIONS_GET_NEW_MONTH_FAILURE
} from '../constants'

export function* getNewCommissionMonthSaga() {
  try {
      const newMonth =  yield call(BFFAgent.Commission.getNewCommissionMonth)

      yield put({
          type: COMMISSIONS_GET_NEW_MONTH_SUCCESS,
          data: newMonth
      })
      
  } catch (error) {
    yield put({
      type: COMMISSIONS_GET_NEW_MONTH_FAILURE,
      data: { error }
    })
  }
}
